import * as React from "react";
import { TTranslate } from "../../../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import { IUserCode } from "../../../../../model/user/UserCode";
import PeriodPermissionForm from "./PeriodPermissionForm";

export interface State {}

export interface CreateReportingPeriodPermissionFormProps
  extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  codebooks: IUserCode[];
}

class CreateReportingPeriodPermissionForm extends React.Component<
  CreateReportingPeriodPermissionFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let newReportingPeriodPermissionData = null;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          newReportingPeriodPermissionData = values;
        }
      });
      return newReportingPeriodPermissionData;
    });
  }

  render() {
    const { translate, codebooks } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <PeriodPermissionForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        codebooks={codebooks}
      />
    );
  }
}

export default CreateReportingPeriodPermissionForm;
